<file-operation-list [idPrefix]="(idPrefix + smpFileCategory + '.file_list.')"
                     [fileMetaList]="fileMetaList"
                     [withIconAvatars]="true"
                     [dynamicDeleteBtnFn]="dynamicDeleteBtnFn"
                     [labelProp]="labelProp"
                     (view)="viewFile($event)"
                     (download)="downloadFile($event)"
                     (delete)="deleteFile($event)"
                     [disabledOptions]="disabledOptions"
                     [disabled]="disabled">
</file-operation-list>
